var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    staticClass: "mdi-card",
    attrs: {
      stripe: "",
      color: "primary",
      "row-key": "id",
      selection: "multiple",
      separator: "horizontal",
      dense: "",
      resource: _vm.resource,
      filter: _vm.filter,
      loading: _vm.loading,
      columns: _vm.columns,
      data: _vm.serverData,
      pagination: _vm.pagination,
      selected: _vm.selectedRows,
      "rows-per-page-options": [0, 25, 50, 100, 250],
      "visible-columns": _vm.visibleColumnsSync
    },
    on: {
      request: _vm.request,
      selection: _vm.handleSelectionChange,
      "update:pagination": function($event) {
        _vm.pagination = $event
      },
      "update:selected": function($event) {
        _vm.selectedRows = $event
      },
      "update:visibleColumns": function($event) {
        _vm.visibleColumnsSync = $event
      },
      "update:visible-columns": function($event) {
        _vm.visibleColumnsSync = $event
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "top",
          fn: function(props) {
            return _c(
              "div",
              { staticClass: "full-width q-pt-sm q-pb-sm" },
              [
                _c(
                  "transition",
                  {
                    attrs: {
                      mode: "out-in",
                      "enter-active-class": "animated flipInX",
                      "leave-active-class": "animated flipOutX"
                    }
                  },
                  [
                    !_vm.selectedRows.length
                      ? _c(
                          "div",
                          {
                            key: "search-bar",
                            staticClass: "row flex-center gutter-md",
                            staticStyle: { "animation-duration": "0.4s" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-6" },
                              [
                                _c("auto-saver", {
                                  attrs: {
                                    duration: 900,
                                    "d-bounce": _vm.handleSearch,
                                    value: _vm.search
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(props) {
                                          return _c("q-input", {
                                            staticClass:
                                              "full-width no-shadow q-body-1",
                                            attrs: {
                                              loading: props.isSaving,
                                              before: [{ icon: "search" }],
                                              placeholder: "Search all records",
                                              color: "secondary",
                                              clearable: "",
                                              "hide-underline": ""
                                            },
                                            on: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "esc",
                                                    27,
                                                    $event.key,
                                                    ["Esc", "Escape"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                _vm.search = ""
                                              }
                                            },
                                            model: {
                                              value: _vm.search,
                                              callback: function($$v) {
                                                _vm.search = $$v
                                              },
                                              expression: "search"
                                            }
                                          })
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-3 text-right" },
                              [
                                _c("q-table-columns", {
                                  staticClass: "q-body-1 full-width",
                                  attrs: {
                                    label: "Visible Columns",
                                    columns: _vm.columns
                                  },
                                  model: {
                                    value: _vm.visibleColumnsSync,
                                    callback: function($$v) {
                                      _vm.visibleColumnsSync = $$v
                                    },
                                    expression: "visibleColumnsSync"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          }
        },
        {
          key: "top-row",
          fn: function(props) {
            return _c("filter-bar", {
              attrs: { cols: props.cols, resource: _vm.resource },
              on: {
                change: function($event) {
                  return _vm.request({ pagination: _vm.pagination })
                }
              }
            })
          }
        },
        _vm._l(_vm.visibleColumns, function(column, columnIndex) {
          return {
            key: "body-cell-" + column.name,
            fn: function(props) {
              return [
                _c(
                  "q-td",
                  { key: columnIndex, attrs: { align: column.align } },
                  [
                    _c("grid-cell", {
                      attrs: {
                        column: column,
                        row: props.row,
                        id: props.row.id,
                        value: props.value,
                        resource: _vm.resource,
                        trashed: false,
                        "client-route": _vm.clientRoute
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        })
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }